<template>
  <div v-if="relativeRelationsData" class="">
    <div class="table-container">
      <table class="my-table">
        <thead>
          <tr>
            <th>#</th>
            <th>{{ $t("nameAr") }}</th>
            <th>{{ $t("nameEn") }}</th>
            <th>{{ $t("notes") }}</th>
            <th
              v-if="
                checkPrivilege(
                  usersEstablishmentPrivilegeData
                    .usersPrivilegAdditionalSettings.additionalSettingsUpdate
                )
              "
            >
              {{ $t("edit") }}
            </th>
            <th
              v-if="
                checkPrivilege(
                  usersEstablishmentPrivilegeData
                    .usersPrivilegAdditionalSettings.additionalSettingsArchive
                )
              "
            >
              {{ $t("delete") }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(relativeRelation, index) in relativeRelationsData"
            :key="relativeRelation.relativeRelationToken"
          >
            <td>{{ ++index + pagination.currentIndex }}</td>
            <td>{{ relativeRelation.relativeRelationNameAr }}</td>
            <td>{{ relativeRelation.relativeRelationNameEn }}</td>
            <td>
              {{
                relativeRelation.relativeRelationNotes
                  ? relativeRelation.relativeRelationNotes
                  : $t("notFound")
              }}
            </td>
            <td
              v-if="
                checkPrivilege(
                  usersEstablishmentPrivilegeData
                    .usersPrivilegAdditionalSettings.additionalSettingsUpdate
                )
              "
            >
              <router-link
                :to="{
                  name: 'RelativeRelationEdit',
                  params: {
                    relativeRelationToken:
                      relativeRelation.relativeRelationToken,
                  },
                }"
                :title="$t('edit')"
              >
                <img src="@/assets/images/pencil.svg" class="icon-lg" />
              </router-link>
            </td>
            <td
              v-if="
                checkPrivilege(
                  usersEstablishmentPrivilegeData
                    .usersPrivilegAdditionalSettings.additionalSettingsArchive
                )
              "
            >
              <button
                v-b-modal.RelativeRelationDelete
                class="btn p-0"
                :title="$t('delete')"
                @click="setRelativeRelationData(relativeRelation)"
              >
                <img src="@/assets/images/trash.svg" class="icon-lg" />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import privilegeMixin from "@/utils/privilege-mixin";

export default {
  name: "RelativeRelationsTable",
  mixins: [privilegeMixin],
  data() {
    return {
      language: localStorage.getItem("userLanguage") || "ar",
    };
  },
  props: ["relativeRelationsData", "relativeRelationData", "pagination"],
  methods: {
    setRelativeRelationData(relativeRelationData) {
      this.$emit("setRelativeRelationData", relativeRelationData);
    },
  },
  computed: {},
};
</script>

<style lang="scss"></style>
